export function puppyDataQueryDefinition(puppyId) {
  return {
    url: `/api/puppies/${puppyId}.json`,
    defaultValue: {},
    createFetchDataConfig: {
      ignoreRescueOn: [404]
    }
  };
}
